import styled from 'styled-components';

export const TabContainer = styled.div`
  align-self: end;
`;
